<template>
  <div class="quick-menu">
    <el-drawer
      direction="ltr"
      :visible.sync="drawer"
      :modal="false"
      :with-header="false"
      @open="open"
      size="280px"
    >
      <div class="content">
        <div class="title">
          <div @click="go('home')" class="home">
            <svg-icon icon-class="home_home-page" style="font-size: 16px;"></svg-icon>
            <span style="margin-left: 4px">首页</span>
          </div>
          <span class="close-drawer" @click="closeDrawer">
            <svg-icon icon-class="close-drawer"></svg-icon>
          </span>
        </div>
        <div class="work-app menu-item">
          <div v-if="type != 'preview'">
            <el-button type="text" class="el-icon-arrow-left button-back" @click="type = 'preview'">
              返回
            </el-button>
            <div style="padding: 10px 20px;flex-shrink: 0;">
              <el-input
                v-model="searchText"
                size="mini"
                clearable
                prefix-icon="el-icon-search"
                :autofocus="false"
              ></el-input>
            </div>
          </div>
          <div v-ps class="collapse-wrap">
            <div v-if="type == 'preview'">
              <span class="main-title">应用</span>
              <div title="应用" name="App">
                <div v-if="starApps.length > 0" class="subhead">
                  <svg-icon icon-class="redStar"></svg-icon>
                  星标应用
                </div>
                <div v-else class="subhead">全部应用</div>
                <div v-show="apps.length == 0" class="empty-text">暂无应用</div>
                <div class="app-list">
                  <div
                    class="app-item pointer"
                    v-for="app in starApps.length > 0 ? starApps.slice(0, 5) : apps.slice(0, 5)"
                    :key="app.id"
                    @click="clickCard('app', app)"
                  >
                    <div class="app-icon" :style="{ background: app.color }">
                      <svg-icon :icon-class="app.icon ? 'app_' + app.icon : 'app'"></svg-icon>
                    </div>
                    <div class="app-name" v-tip="1">{{ app.name }}</div>
                  </div>
                  <div
                    class="app-show-more pointer"
                    v-if="apps.length >= 5"
                    @click="openAll('app')"
                  >
                    <div class="app-icon" style="background:#F5F7FA">
                      <svg-icon icon-class="spread" style="font-size: 20px"></svg-icon>
                    </div>
                    <div class="app-name" v-tip="1">展开全部</div>
                  </div>
                </div>
              </div>
              <div class="project-title">项目</div>
              <div title="项目" name="Project" class="project-group">
                <div v-if="starProjects.length > 0" class="subhead">
                  <svg-icon icon-class="redStar"></svg-icon>
                  星标项目
                </div>
                <div v-else class="subhead">全部项目</div>
                <div v-show="projects.length == 0" class="empty-text">暂无项目</div>
                <div class="project-list">
                  <div
                    v-for="project in starProjects.length > 0
                      ? starProjects.slice(0, 5)
                      : projects.slice(0, 5)"
                    :key="project.id"
                    @click="clickCard('project', project)"
                    class="project-item pointer"
                  >
                    <div class="project-icon" :style="{ background: '#1989FA' }">
                      <svg-icon
                        :icon-class="project.icon ? 'project_' + project.icon : 'project_folder'"
                      ></svg-icon>
                    </div>
                    <div v-tip class="project-name">{{ project.name }}</div>
                    <el-progress
                      :percentage="project.completeRate | getPercentage"
                      class="progress"
                      color="#1989FA"
                    ></el-progress>
                  </div>
                  <div
                    class="show-more pointer"
                    v-if="projects.length >= 5"
                    @click="openAll('project')"
                  >
                    <div class="project-icon" style="background: #F5F7FA">
                      <svg-icon icon-class="spread" style="font-size: 20px"></svg-icon>
                    </div>
                    <div v-tip class="project-name">展开全部</div>
                  </div>
                </div>
              </div>
            </div>
            <el-collapse v-else-if="type == 'app'" v-model="appActiveNames" @change="handleChange">
              <el-collapse-item v-show="filteredApps.length > 0" name="星标应用">
                <template slot="title">
                  <div class="collapse-title">
                    <svg-icon icon-class="redStar"></svg-icon>
                    星标应用
                  </div>
                </template>
                <div class="app-list">
                  <div
                    class="app-item pointer"
                    v-for="app in filteredApps"
                    :key="app.id"
                    @click="clickCard('app', app)"
                  >
                    <div class="app-icon" :style="{ background: app.color }">
                      <svg-icon :icon-class="app.icon ? 'app_' + app.icon : 'app'"></svg-icon>
                    </div>
                    <div class="app-name" v-tip="1">{{ app.name }}</div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                v-for="(items, index) in filteredAppGroup"
                v-show="items.appList.length > 0"
                :name="items.name"
                :key="index"
              >
                <template slot="title" v-bind:title="items">
                  <div class="collapse-title">
                    {{ items.name }}
                  </div>
                </template>
                <div class="app-list" v-if="items.appList">
                  <div
                    class="app-item pointer"
                    v-for="app in items.appList"
                    :key="app.id"
                    @click="clickCard('app', app)"
                  >
                    <div class="app-icon" :style="{ background: app.color }">
                      <svg-icon :icon-class="app.icon ? 'app_' + app.icon : 'app'"></svg-icon>
                    </div>
                    <div class="app-name" v-tip="1">{{ app.name }}</div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <el-collapse
              v-else-if="type == 'project'"
              v-model="projectActiveNames"
              @change="handleChange"
            >
              <el-collapse-item v-show="filteredProjects.length > 0" name="星标项目">
                <template slot="title">
                  <div class="collapse-title">
                    <svg-icon icon-class="redStar"></svg-icon>
                    星标项目
                  </div>
                </template>
                <div class="project-list">
                  <div
                    v-for="project in filteredProjects"
                    :key="project.id"
                    @click="clickCard('project', project)"
                    class="project-item pointer"
                  >
                    <div class="project-icon" :style="{ background: '#1989FA' }">
                      <svg-icon
                        :icon-class="project.icon ? 'project_' + project.icon : 'project_folder'"
                      ></svg-icon>
                    </div>
                    <div v-tip class="project-name">{{ project.name }}</div>
                    <el-progress
                      :percentage="project.completeRate | getPercentage"
                      class="progress"
                      color="#1989FA"
                    ></el-progress>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                v-for="(items, index) in filteredProjectGroup"
                v-show="items.projectList.length > 0"
                :key="index"
                :title="items.name"
                :name="items.name"
              >
                <template slot="title" v-bind:title="items">
                  <div class="collapse-title">
                    {{ items.name }}
                  </div>
                </template>
                <div class="project-list" v-if="items.projectIdList">
                  <div
                    v-for="project in items.projectList"
                    :key="project.id"
                    @click="clickCard('project', project)"
                    class="project-item pointer"
                  >
                    <div class="project-icon" :style="{ background: '#1989FA' }">
                      <svg-icon
                        :icon-class="project.icon ? 'project_' + project.icon : 'project_folder'"
                      ></svg-icon>
                    </div>
                    <div v-tip class="project-name">{{ project.name }}</div>
                    <el-progress
                      :percentage="project.completeRate | getPercentage"
                      class="progress"
                      color="#1989FA"
                    ></el-progress>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getAppList } from "@/api/userCenter/app"
import { defaultLogo } from "~/data/static"
import { canManageCompany } from "@/utils/checkPermission"
import { getProjectList } from "@/api/project/project"
import { getFavoriteList, getAppGroupList, getProjectGroupList } from "@/api/user"

export default {
  name: "QuickMenu",
  filters: {
    getPercentage(val) {
      return Math.floor(val * 100)
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    },
    filteredApps() {
      if (!this.searchText) return this.starApps
      return this.starApps.filter(app => app.name.includes(this.searchText))
    },
    filteredAppGroup() {
      if (!this.searchText) return this.appGroup
      return this.appGroup.map(apps => {
        return {
          name: apps.name,
          appList: apps.appList.filter(app => app.name.includes(this.searchText))
        }
      })
    },
    filteredProjects() {
      if (!this.searchText) return this.starProjects
      return this.starProjects.filter(project => project.name.includes(this.searchText))
    },
    filteredProjectGroup() {
      if (!this.searchText) return this.projectGroup
      return this.projectGroup.map(projects => {
        return {
          name: projects.name,
          projectList: projects.projectList.filter(project =>
            project.name.includes(this.searchText)
          )
        }
      })
    },
    canManageCompany() {
      return canManageCompany(this.curUser.companyId)
    }
  },
  watch: {
    "curUser.companyId"(newVal, oldVal) {
      newVal && this.refresh()
    }
  },
  data() {
    return {
      logo: defaultLogo,
      drawer: false,
      loading: false,
      apps: [],
      projects: [],
      searchText: "",
      type: "preview",
      appGroup: [],
      projectGroup: [],
      appList: [],
      projectList: [],
      appActiveNames: [],
      projectActiveNames: [],
      starApps: [],
      starProjects: []
      // oldActiveNames: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    open() {
      this.refresh()
      // this.oldActiveNames = this.activeNames
    },
    refresh() {
      // 如果没选择企业,则不请求接口
      if (!this.curUser.companyId) {
        return
      }
      this.type = "preview"
      this.loading = true
      Promise.all([this.getCompanyApps(), this.getCompanyProjects()]).then(() => {
        this.loading = false
      })
    },
    getCompanyApps() {
      return getAppList("MEMBER").then(apps => {
        this.appList = apps
        this.getAppFavoriteList()
        this.getAppGroupList()
      })
    },
    getCompanyProjects() {
      return getProjectList({ withCount: true }).then(projects => {
        this.projectList = projects.filter(i => !i.suspended)
        this.getProjectFavoriteList()
        this.getProjectGroupList()
      })
    },
    getAppFavoriteList() {
      getFavoriteList("app").then(res => {
        if (!res || res.length == 0) {
          this.apps = this.appList
          this.starApps = []
          return
        }
        this.starApps = res
          .map(appId => {
            return this.appList.find(x => x.id == appId)
          })
          .filter(x => x)

        if (this.starApps.length > 0) {
          this.appActiveNames.push("星标应用")
        }
        this.apps = this.appList
      })
    },
    getProjectFavoriteList() {
      getFavoriteList("project").then(res => {
        if (!res || res.length == 0) {
          this.projects = this.projectList
          this.starProjects = []
          return
        }
        this.starProjects = res
          .map(projectId => {
            return this.projectList.find(x => x.id == projectId)
          })
          .filter(x => x)
        if (this.starProjects.length > 0) {
          this.projectActiveNames.push("星标项目")
        }
        this.projects = this.projectList
      })
    },
    getAppGroupList() {
      getAppGroupList().then(res => {
        if (!res || res.length == 0) this.appGroup[0] = { name: "全部应用", appList: this.appList }
        else {
          let alreadyApps = []
          for (let list of res) {
            list.appList = []
            this.appActiveNames.push(list.name)
            list.appIdList.forEach(appId => {
              let appSelect = this.appList.find(x => x.id == appId)
              if (appSelect) list.appList.push(appSelect)
            })
            if (list.appList) alreadyApps = alreadyApps.concat(list.appList)
          }
          this.appGroup = res
          let unGroupApps = []
          for (let app of this.appList) {
            if (!alreadyApps.some(x => x.id == app.id)) unGroupApps.push(app)
          }
          if (!this.unGroupApps) {
            this.appGroup.push({
              name: "未分组项",
              appList: unGroupApps
            })
            this.appActiveNames.push("未分组项")
          }
        }
      })
    },
    getProjectGroupList() {
      getProjectGroupList().then(res => {
        if (!res || res.length == 0)
          this.projectGroup[0] = {
            name: "全部项目",
            projectList: this.projectList
          }
        else {
          let alreadyProjects = []
          for (let list of res) {
            list.projectList = []
            this.projectActiveNames.push(list.name)
            list.projectIdList.forEach(projectId => {
              let projectSelect = this.projectList.find(x => x.id == projectId)
              if (projectSelect) list.projectList.push(projectSelect)
            })
            if (list.projectList) alreadyProjects = alreadyProjects.concat(list.projectList)
          }
          this.projectGroup = res
          let unGroupprojects = []
          for (let project of this.projectList) {
            if (!alreadyProjects.some(x => x.id == project.id)) unGroupprojects.push(project)
          }
          if (!unGroupprojects) {
            this.projectGroup.push({
              name: "未分组项",
              projectList: unGroupprojects
            })
            this.projectActiveNames.push("未分组项")
          }
        }
      })
    },
    handleChange(activeNames) {
      // if (this.oldActiveNames.includes("Project") && !activeNames.includes("Project")) {
      //   document.querySelector(".collapse-wrap .el-collapse").scrollIntoView({ block: "start" })
      // }
      // this.oldActiveNames = this.activeNames
    },
    go(routerName) {
      this.closeDrawer()
      this.$router.goto({ name: routerName })
    },
    openDrawer() {
      this.drawer = true
    },
    closeDrawer() {
      this.drawer = false
      this.type = "preview"
    },
    goCompany() {
      this.closeDrawer()
      const { href } = this.$router.resolve({
        name: "company-home-page"
      })
      window.open(href, "_blank")
    },
    goApp() {
      this.closeDrawer()
      this.$router.goto({ name: "home" })
    },
    clickCard(type, item) {
      this.closeDrawer()
      if (type == "app") {
        this.$router.push({ name: "worksheet", params: { appId: item.id } })
      } else if (type == "project") {
        this.$router.push({ name: "project-task-list", params: { projectId: item.id } })
      }
    },
    openAll(type) {
      this.type = type
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-menu {
  ::v-deep {
    .el-drawer {
      &:focus {
        outline: none;
      }
    }
  }
}
.collapse-title {
  font-size: 14px;
  color: #8f9193;
}
.content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: $navbar-height;
    justify-content: space-between;
    .home {
      color: #878a90;
      width: 60px;
      background-color: #f2f3f5;
      border-radius: 6px;
      margin-left: 20px;
      padding: 4px;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
    }
    .close-drawer {
      font-size: 18px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .border {
    border-bottom: 1px solid #e4e4e4;
  }
  .menu-item {
    ::v-deep .el-input__inner {
      height: 32px;
    }
    .sub-title {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      height: 46px;
      padding: 0 20px;
      &:hover {
        cursor: default;
        background: $color-bg-select;
      }
    }
    .button-back {
      padding: unset;
      margin-left: 15px;
      color: #8f9193;
    }
  }
  .work-app {
    flex: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .empty-text {
      @include flex-center;
      min-height: 32px;
      font-size: 14px;
      color: $color-font-second;
      margin: 20px 0 0 0;
    }
    .app-list {
      display: flex;
      flex-wrap: wrap;
      padding-left: 20px;
      .app-item {
        width: 74px;
        height: 88px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        margin-bottom: 5px;
        .app-name {
          text-align: center;
          width: 100%;
          font-size: $font-size-secondary;
          color: $color-font-title;
        }
        &:hover {
          box-shadow: 1px 1px 4px 1px #eeeff4;
          border-radius: 4px;
        }
      }
      .app-show-more {
        width: 74px;
        height: 88px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        margin-bottom: 5px;
        .app-name {
          text-align: center;
          width: 100%;
          font-size: $font-size-secondary;
          color: $color-font-title;
        }
      }
    }
    .app-show-more .app-icon,
    .show-more .project-icon,
    .app-item .app-icon,
    .project-item .project-icon {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 42px;
      height: 42px;
      background: #1989fa;
      border-radius: 10px;
      margin-bottom: 6px;
      font-size: 28px;
      color: #fff;
    }
    .project-list {
      padding: 10px 10px 20px;
      .project-item {
        display: flex;
        align-items: center;
        padding: 12px 10px;
        border-radius: 4px;
        &:hover {
          box-shadow: 1px 1px 4px 1px #eeeff4;
        }
      }
      .show-more {
        display: flex;
        align-items: center;
        padding: 12px 10px;
        border-radius: 4px;
      }
      .project-name {
        @include ellipsis;
        margin-left: 6px;
        margin-right: 3px;
        font-size: 12px;
      }
      .progress {
        min-width: 80px;
        margin-left: auto;
        display: grid;
        ::v-deep {
          .el-progress-bar {
            width: 80px;
            padding-right: 0;
            box-sizing: content-box;
          }
          .el-progress__text {
            font-size: 12px !important;
            text-align: center;
            margin-left: 0;
            margin-top: 5px;
          }
        }
      }
    }
    .collapse-wrap {
      flex: 1 1;
      margin-top: 10px;
      ::v-deep {
        .el-collapse,
        .el-collapse-item__wrap,
        .el-collapse-item__header {
          border: none;
        }
        .el-collapse-item {
          &:not(:first-child) {
            margin-top: 12px;
          }
          .el-collapse-item__header {
            padding: 0 20px;
            font-size: 16px;
            color: $color-font-first;
            .el-collapse-item__arrow {
              color: $color-font-second;
              font-weight: bold;
            }
          }
        }
        .el-collapse-item__content {
          padding-bottom: 0;
        }
      }
      .main-title {
        padding-left: 20px;
        font-weight: 600;
      }
      .project-title {
        padding-left: 20px;
        margin-top: 22px;
        font-weight: 600;
      }
      .subhead {
        padding-left: 20px;
        font-size: 14px;
        color: #313132;
        padding-top: 12px;
      }
    }
  }
}
</style>
